/**
 * Agence'O - select
 * @author Axel Baron (Agence'O)
 * @created 12/06/2019
 */

(function ($) {

  $(".keyword").on('keyup', (e) => {
    const $this = $(e.currentTarget);
    const exp = new RegExp($this.val(), 'i');
    $(".js-special-search__result1 li label").each((i, item) => {
      const $self = $(item);
      if (!exp.test($self.text())) {
        $self.parent().hide();
      } else {
        $self.parent().show();
      }
    });
  });


  $(".keyword2").on('keyup', (e) => {
    e.stopPropagation();
    e.preventDefault();
    const $this = $(e.currentTarget);
    const exp = new RegExp($this.val(), 'i');
    $(".js-special-search__result2 li").each((i, item) => {
      const $self = $(item);
      if (!exp.test($self.text())) {
        $self.hide();
      } else {
        $self.show();
      }
    });
  });

  $(".special-search__result, .special-search__search").on('click', (e) => {
    e.stopPropagation();
  });

  ///////////////// SELECT //
  $(".special-search--content-hide input").on('click', (e) => {
    e.stopPropagation();
    let target = $(e.currentTarget);
    let parent = target.parents('.special-search--content-hide').eq(0);
    parent.addClass('active');
    parent.find('.special-search__result').show();
  });

  $(document).on('click', () => {
    $('.special-search--content-hide').removeClass('active');
    $('.special-search--content-hide .special-search__result').hide();
  });

  $(".special-search--content-hide li").on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    let target = $(e.currentTarget);
    let text = target.text();
    let parent = target.parents('.special-search--content-hide').eq(0);
    parent.find('input').val(text);
    parent.removeClass('active');
    $('.special-search--content-hide .special-search__result').hide();
  });

  $(".special-search__result input").on('change', () => {
    let numberOfChecked = $('.special-search__result input:checkbox:checked').length;
    $('.fake-select__check-number i').text(numberOfChecked);
  });

  $('[data-toggle="datepicker"]').datepicker({
     // endDate: 'now',
      language: 'fr-FR'
  });

}(jQuery));
